import Button from '@cloudscape-design/components/button';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { MarketingContainer } from '@vextura/shell';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { HERO } from '../content.js';

/**
 * Hero — top of the page. Dark gradient background, big display headline
 * with a gradient tail on the second line, two CTAs, and a trust line
 * naming the reference customer. This section earns everything below it.
 */
export function Hero(): ReactNode {
  const navigate = useNavigate();
  return (
    <MarketingContainer variant="dark" paddingY="spacious">
      <div style={{ textAlign: 'center', maxWidth: 900, margin: '0 auto' }}>
        <SpaceBetween size="l">
          <div>
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                padding: '6px 14px',
                fontSize: 13,
                fontWeight: 500,
                color: '#a5b4fc',
                background: 'rgba(99, 102, 241, 0.10)',
                border: '1px solid rgba(99, 102, 241, 0.30)',
                borderRadius: 999,
              }}
            >
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: '50%',
                  background: '#818cf8',
                  boxShadow: '0 0 0 3px rgba(129, 140, 248, 0.25)',
                }}
              />
              {HERO.eyebrow}
            </span>
          </div>
          <h1
            style={{
              fontSize: 'clamp(40px, 6vw, 72px)',
              lineHeight: 1.05,
              fontWeight: 800,
              letterSpacing: -1.2,
              margin: 0,
              color: '#f8fafc',
            }}
          >
            {HERO.headline}
            <br />
            <span
              style={{
                background: 'linear-gradient(90deg, #818cf8, #c084fc)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {HERO.headlineTail}
            </span>
          </h1>
          <p
            style={{
              fontSize: 20,
              lineHeight: 1.5,
              color: '#cbd5e1',
              maxWidth: 720,
              margin: '0 auto',
            }}
          >
            {HERO.subhead}
          </p>
          <div
            style={{
              display: 'flex',
              gap: 12,
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginTop: 8,
            }}
          >
            <Button
              variant="primary"
              onClick={() => navigate(HERO.primaryCta.href)}
            >
              {HERO.primaryCta.label} →
            </Button>
            <Button variant="normal" onClick={() => navigate(HERO.secondaryCta.href)}>
              {HERO.secondaryCta.label}
            </Button>
          </div>
          <div
            style={{
              marginTop: 24,
              fontSize: 14,
              color: '#94a3b8',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                background: '#10b981',
                boxShadow: '0 0 0 3px rgba(16, 185, 129, 0.20)',
              }}
            />
            {HERO.trustLine}
          </div>
        </SpaceBetween>
      </div>
    </MarketingContainer>
  );
}
